import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import CustomControl from '../../../../../../../../../components/global/CustomControl';
import {
  formatPriceForDisplay,
  formatNumber,
} from '../../../../../../../../../util/format-money';

const propTypes = {
  photoFinderCreditItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      credits: PropTypes.number,
    }).isRequired,
  ),
  onSelectionChange: PropTypes.func,
  selectable: PropTypes.bool,
  defaultPhotoFinderCreditItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

const PhotoFinderCreditItemsTable = ({
  photoFinderCreditItems,
  onSelectionChange,
  selectable,
  defaultPhotoFinderCreditItem = null,
}) => {
  const [selectedCreditItem, setSelectedCreditItem] = useState(
    defaultPhotoFinderCreditItem,
  );

  useEffect(() => {
    if (defaultPhotoFinderCreditItem) {
      setSelectedCreditItem(defaultPhotoFinderCreditItem);
    }
  }, [defaultPhotoFinderCreditItem]);

  if (!photoFinderCreditItems || photoFinderCreditItems?.length === 0) {
    return null;
  }

  return (
    <div className="table-responsive horizontal-scroller">
      <table className="table table-striped">
        <tbody>
          {photoFinderCreditItems.map(creditItem => {
            return (
              <tr
                key={creditItem.id}
                className="cursor-pointer"
                onClick={() => {
                  setSelectedCreditItem(creditItem);
                  onSelectionChange(creditItem);
                }}
              >
                <td className="d-flex align-items-center">
                  {selectable && (
                    <CustomControl
                      id={`checkbox-${creditItem.id}`}
                      type="checkbox"
                      labelSrOnly
                      label="Select plan"
                      className="mr-2"
                      checked={selectedCreditItem?.id === creditItem.id}
                      onChange={event => {
                        event.stopPropagation();
                        setSelectedCreditItem(creditItem);
                        onSelectionChange(creditItem);
                      }}
                    />
                  )}
                  {formatNumber(creditItem.amount)}
                </td>
                <td className="text-right">
                  $
                  {formatNumber(
                    formatPriceForDisplay(creditItem.price.value, true),
                  )}{' '}
                  <span className="text-light text-xs">
                    ($
                    {formatPriceForDisplay(
                      creditItem.price.value / creditItem.amount,
                      true,
                      2,
                    )}{' '}
                    / credit)
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

PhotoFinderCreditItemsTable.propTypes = propTypes;

export default PhotoFinderCreditItemsTable;
